import React from "react";
import { createPortal } from "react-dom";
import styled, { ThemeProvider } from "styled-components";
import { defaultTheme } from "../../../theme/theme";
import zIndexTypes from "../../../theme/zIndexTypes";

const ModalContainer = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  isolation: isolate;
  z-index: ${zIndexTypes.modal};
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

const Modal = (props: Props) => {
  const { isOpen, children, id } = props;

  if (!isOpen) {
    return null;
  }

  return createPortal(
    // Because we are using a portal the component is rendered outside of the
    // theme scope, so we need to add it here.
    <ThemeProvider theme={defaultTheme}>
      <ModalContainer id={id}>{children}</ModalContainer>
    </ThemeProvider>,
    document.getElementById("react-portal")
  );
};

type Props = {
  id?: string;
  isOpen: boolean;
  onDismiss: () => void;
  children: React.ReactChild[];
};

export default Modal;
